import { LocalDateTime } from "@js-joda/core";

export type typeBalance = {
  readonly id?: string;
  readonly noteCapacity: number;
  readonly coinCapacity: number;
  readonly currency: string;
  readonly maxNoteCapacity?: string;
  readonly maxCoinCapacity?: string;
  readonly currentDepositAmount?: number;
  readonly todayDepositAmount: number;
};
export interface BalanceItem {
  [key: string]: any;
  id: string;
  type: string; //logic/point
  name: string;
  logicCashTodayId?: string;
  logicCashTodayName?: string;
  servicePointId: string;
  servicePointName: string;
  cashTodayType: string;
  centerName: string;
  entityName: string;
  maxNoteCapacity: number;
  maxCoinCapacity: number;
  deviceFillPercentage: number;
  capacityEnabled?: boolean;
  deviceCode?: string;
  deviceType: string;
  isEarlyValue: boolean;
  lastCertificationDate?: LocalDateTime;
  lastTransactionDate?: LocalDateTime;
  solutionType: string;
  balances: typeBalance[];
}

export interface Establishment {
  id: string;
  name: string;
  num: number;
}

export const DEVICE_TYPE_ACCEPTOR = "ACCEPTOR";
export const DEVICE_TYPE_AC = "AC";
export const DEVICE_TYPE_RECYCLER = "RECYCLER";
export const DEVICE_TYPE_RE = "RE";
